export const floatingMenu = {
  floatingMenuHome: "Home",
  floatingMenuSlots: "Slots",
  floatingMenuGames: "Games",
  floatingMenuSports: "Sports",
  floatingMenuLottery: "Lottery",
  floatingMenuCasino: "Casino",
  floatingMenuFeed: "Feed",
  floatingMenuBingo: "Bingo",
  floatingMenuToPlay: "Play",
  floatingMenuCategories: "Categories",
  floatingMenuSeeAllGames: "Go to all games",
  floatingMenuSeeAllSports: "Go to all sports",
};
